module.exports = __webpack_public_path__ + "static/media/book-heart.663a3847.svg";